/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import {
    activateInjectableContent,
    setInjectedId,
    deactivateContent,
    deactivateContents,
    removeInjectedContentId,
    removeInjectedLayoutIds,
    pauseMultipleContents,
    resumeMultiplePausedContents
} from 'redux/actions/content_status';
import { clearContentsData } from 'redux/actions/content_data';
import { resetMultipleQueues } from 'redux/actions/queue_status';
import { storePausedState, clearPausedState } from "redux/actions/pause_status";
// batching action creator that enables batching subscriber notifications for an array of actions.
import { batchActions } from 'redux-batched-actions';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Content from 'components/content/content';



/* ========== ~~~~~~~~~~ CONTENT : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, queueStatus, sessionStatus, rewards }, { contentId }) => {
    const currentContentStatus = contentStatus[contentId];
    const frame = currentContentStatus['frame'];
    const injectablesAtFrame = currentContentStatus.injectablesAtFrame;
    const currentContentSettings = settings.contentSettings[contentId];
    const injectables = currentContentSettings.injectables;
    const queuePosition = currentContentSettings.queuePosition
    const killInjectablesOnCompletion = currentContentSettings.killInjectablesOnCompletion;
    const isActive = currentContentStatus.status === 'active';
    return {
        frame,
        contentId,
        contentData,
        contentStatus,
        isActive,
        injectables,
        killInjectablesOnCompletion,
        queue: queueStatus.queue.queue,
        currentContentStatus,
        currentContentSettings,
        queuePosition,
        injectablesAtFrame,
        currentContentData: contentData[contentId],
        embedSettings: settings.embedSettings,
        sessionStatus: sessionStatus,
        frameData: contentData[contentId].data[contentStatus[contentId].frame],
        rewardsEnabled: rewards.settings.enabled,
        rewardsPermitted: rewards.status.rewardsPermitted
}};

// map actions
const mapDispatchToProps = dispatch => ({
    // Combines actions necessary for Content injection into one transaction
    injectContent: (parentContentId, injectableContentId) => dispatch(activateInjectableContent(parentContentId, injectableContentId)),
    injectContentAndPause: (parentContentId, injectableContentId, contentIdsToPause, pauseState) =>
        dispatch(batchActions([
            activateInjectableContent(parentContentId, injectableContentId),
            pauseMultipleContents(contentIdsToPause),
            storePausedState(pauseState)
        ])),
    revertPauseState: (injectableId, pauseState) =>
        dispatch(batchActions([
            resumeMultiplePausedContents(pauseState),
            clearPausedState(injectableId)
        ])),
    killContent: (parentContentId, injectableContentId, injectedWithPauseType, repeatable) =>
        dispatch(batchActions([
            removeInjectedContentId(parentContentId, injectableContentId, repeatable), // includes UNPAUSE functionality (may need to refactor this slightly, having it run below was causing issues)
            deactivateContent(injectableContentId)
        ])),
    deactivateContent: contentId => dispatch(deactivateContent(contentId)),
    // deactivateContents: contentIds => dispatch(deactivateContents(contentIds)),
    deactivateContents: contentIds =>
        dispatch(batchActions([
            deactivateContents(contentIds),
            clearContentsData(contentIds)
        ])),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);
